import React from 'react';
import defaultImage from '../../../../public/images/no-image-image.png';

type Props = {
  imageWidth?: string,
  imageSource: string,
  imageCustomLabel?: boolean,
  imageUrl?: string,
  dataId?: string,
};

function ItemImage(props: Props) {
  const { imageWidth, imageSource, imageCustomLabel, imageUrl, dataId } = props;
  const source = imageSource || defaultImage;
  return (
    <div className="lineItem__image-wrapper" style={{ width: imageWidth }}>
      {/* create custom label on image */}
      {imageCustomLabel && (
        <div className="custom__blind_logo">{imageCustomLabel}</div>
      )}
      {/* create link image or default image */}
      {imageUrl ? (
        <a href={imageUrl} target="_self" rel="noopener noreferrer">
          <img
            className="lineItem__image"
            src={source}
            alt="itemImage"
            data-automation-id={dataId && dataId}
          />
        </a>
      ) : (
        <img
          className="lineItem__image"
          src={source}
          alt="itemImage"
          data-automation-id={dataId && dataId}
        />
      )}
    </div>
  );
}

ItemImage.defaultProps = {
  imageWidth: 'auto',
  imageCustomLabel: false,
  imageUrl: null,
  dataId: null,
};

export default ItemImage;
